<template>
  <div>
    <MyGridLayout :layout-data="layoutData" v-if="isGridShow"/>
    <div v-show="this.RCTD.data.length !== 0">
      <h3>RCTD</h3>
      <div id="dataset_celltype_rctd">
        <div class="left2">
          <div id="rctd_vue" style="height: 400px;width: 400px"/>
        </div>
        <div class="right2">
          <el-table
              stripe
              border
              max-height="400"
              size="mini"
              style="width: 100%"
              :data="RCTD.data.slice((pageinfo.currentPage-1)*pageinfo.pageSize,pageinfo.currentPage*pageinfo.pageSize)">
            <el-table-column prop="spot" label="spot" sortable show-overflow-tooltip fixed="left" min-width="200"></el-table-column>
            <div v-for="(item,index) in columns" :key="index">
              <el-table-column :prop="item" :label="item" sortable show-overflow-tooltip
                               :formatter="rounding" min-width="100"></el-table-column>
            </div>
          </el-table>
          <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                         :current-page="pageinfo.currentPage"
                         :page-sizes="[10,20,50,100]"
                         :page-size="pageinfo.pageSize"
                         layout="total, sizes, prev, pager, next, jumper"
                         :total="RCTD.data.length">
          </el-pagination>
        </div>
      </div>
    </div>

    <div v-if="haveCell2Location">
      <PieTableCard  :position="position"
                     :datasetID="formData.datasetID"
                     :Array="formData.Array"
                     tableType="cell2location"/>
    </div>

    <div v-if="haveCellChat">
<!--      <PieTableCard  :position="position"-->
<!--                     :datasetID="formData.datasetID"-->
<!--                     :Array="formData.Array"-->
<!--                     tableType="cellchat"/>-->
      <SankeyCard
          :datasetID="formData.datasetID"
          :Array="formData.Array"
          tableType="cellchat"
      />
    </div>
  </div>
</template>

<script>
// import data from '@/components/Dataset/overview.json'
// import data_marker from '@/components/Dataset/overview_table.json'
import * as echarts from "echarts/core";
import MyGridLayout from "@/components/tools/MyGridLayout";
import PieTableCard from "@/components/tools/PicTableCard"
import SankeyCard from "@/components/tools/SankeyCard";

export default {
  name: "Dataset_celltype_grid",
  components: {SankeyCard, MyGridLayout, PieTableCard},
  data() {
    return {
      isGridShow: false,
      layoutData: [
        // { x: 0, y: 0, w: 4, h: 15, i: "0", type: "MarkerCard", data:{datasetID: '', Array: ''} },
      ],
      index: 0,
      position: [],
      groundtruth_source: '',
      echart_info: {
        classification_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        fine_annot_type_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        celltype_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        major_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        minor_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        },
        subset_info: {
          types: [],
          spotSize: 5,
          tip: [],
          source: []
        }
      },
      formData: {
        datasetID: '',
        Array:  '',
      },
      data: [],
      echart_info_celltype2: {
        umap_celltype: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        umap_major: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        umap_minor: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        umap_subset: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        tsne_celltype: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        tsne_major: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        tsne_minor: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
        tsne_subset: {
          types: [],
          spotSize: 2,
          tip: [],
          source: []
        },
      },
      COLOR_ALL: [
        '#37A2DA',
        '#e06343',
        '#37a354',
        '#b55dba',
        '#b5bd48',
        '#8378EA',
        '#96BFFF',
        '#E72178',
        '#354E6C', '#EAAC31',
        '#EAD2AE',
        '#127678', '#30B5A4', '#B4D9D2',
        '#354581', '#FFE074',
        '#E03C79', '#88C1B8',
        '#FC6746', '#F5B307', '#008186'
      ],
      pic_path: {
        pic_celltype1: '',
        pic_celltype2: '',
        pic_major1: '',
        pic_major2: '',
        pic_minor1: '',
        pic_minor2: '',
        pic_subset1: '',
        pic_subset2: '',
      },
      //RCTD
      RCTD: {
        data: []
      },
      haveRCTD: false,
      columns: [],
      list_data: {},
      type: '',
      color2: [
        "#43CD80",
        "#FFDAB9",
        "#FFFF00",
        "#D8BFD8",
        "#436EEE",
        "#FF3E96",
        "#CD8162",
        "#90EE90",
        "#9ACD32",
        "#CD69C9",
        "#CD2990",
        "#2E8B57",
        "#32CD32",
        "#EEC900"
      ],
      pageinfo: {
        currentPage: 1,
        pageSize: 10
      },
      haveCell2Location: false,
      haveCellChat: false,
    }
  },
  props: {
    asyncData: {
      classification_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      fine_annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      annot_type_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      celltype_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      major_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      minor_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      subset_info: {
        types: Array,
        spotSize: Number,
        tip: Array,
        source: Array
      },
      // type:String,  //类型可以定义
      // default:''  //默认是空值
      // type:Object,  default () {return {}}
    },
    asynGround: String,
    datasetInfo: Array,
    sourceData: Array, //annotation table
    sourcePosition: Array,
  },
  mounted() {
    this.data = this.sourceData
    this.position = this.sourcePosition
    this.echart_info = this.asyncData
    this.groundtruth_source = this.asynGround
    this.formData.datasetID = this.datasetInfo[0].datasetID
    this.formData.Array = this.datasetInfo[0].name
    //
    // console.log(this.formData.datasetID)
    // console.log('cell type:')
    // console.log(this.data)
    // console.log(this.position)
    // console.log(this.echart_info_celltype)
    // console.log(this.groundtruth_source)
    // this.data = data.data
    this.getRCTD()
    let hasCelltype = Object.prototype.hasOwnProperty.call(this.data[0], "celltype")
    this.$nextTick(function () {
      (async()=>{
        let PromiseA;
        if (hasCelltype) {
          PromiseA =  this.initEchartsInfo3()
        } else {
          PromiseA = this.initEchartsInfo2()
        }
        let PromiseB = this.getCelltypePic()
        await Promise.all([PromiseA, PromiseB])
        this.haveCell2Location = true
        this.haveCellChat = true
        this.initLayoutData()
      })();
    })
  },
  methods: {
    async initEchartsInfo2() {
      let _this = this
      let temp_types_major = []
      let temp_types_minor = []
      let temp_types_subset = []
      _this.echart_info_celltype2.umap_major.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.umap_minor.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.umap_subset.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.tsne_major.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.tsne_minor.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.tsne_subset.source.push(['type', 'x', 'y'])
      for (let i = 0; i < _this.data.length; i++) {
        _this.echart_info_celltype2.umap_major.source.push([_this.data[i].celltype_major, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
        _this.echart_info_celltype2.umap_minor.source.push([_this.data[i].celltype_minor, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
        _this.echart_info_celltype2.umap_subset.source.push([_this.data[i].celltype_subset, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
        _this.echart_info_celltype2.tsne_major.source.push([_this.data[i].celltype_major, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        _this.echart_info_celltype2.tsne_minor.source.push([_this.data[i].celltype_minor, _this.data[i].tSNE_1, _this.data[i].tSNE_2])
        _this.echart_info_celltype2.tsne_subset.source.push([_this.data[i].celltype_subset, _this.data[i].tSNE_1, _this.data[i].tSNE_2])

        if (!temp_types_major.includes(_this.data[i].celltype_major)) {
          temp_types_major.push(_this.data[i].celltype_major)
        }
        if (!temp_types_minor.includes(_this.data[i].celltype_minor)) {
          temp_types_minor.push(_this.data[i].celltype_minor)
        }
        if (!temp_types_subset.includes(_this.data[i].celltype_subset)) {
          temp_types_subset.push(_this.data[i].celltype_subset)
        }
      }
      // console.log(_this.echart_info.classification_info.source)
      _this.echart_info_celltype2.umap_major.types = temp_types_major
      _this.echart_info_celltype2.umap_minor.types = temp_types_minor
      _this.echart_info_celltype2.umap_subset.types = temp_types_subset
      _this.echart_info_celltype2.tsne_major.types = temp_types_major
      _this.echart_info_celltype2.tsne_minor.types = temp_types_minor
      _this.echart_info_celltype2.tsne_subset.types = temp_types_subset
      if (_this.data.length > 5000) {
        _this.echart_info_celltype2.umap_major.spotSize = 2
        _this.echart_info_celltype2.umap_minor.spotSize = 2
        _this.echart_info_celltype2.umap_subset.spotSize = 2
        _this.echart_info_celltype2.tsne_major.spotSize = 2
        _this.echart_info_celltype2.tsne_minor.spotSize = 2
        _this.echart_info_celltype2.tsne_subset.spotSize = 2
      } else {
        _this.echart_info_celltype2.umap_major.spotSize = 4
        _this.echart_info_celltype2.umap_minor.spotSize = 4
        _this.echart_info_celltype2.umap_subset.spotSize = 4
        _this.echart_info_celltype2.tsne_major.spotSize = 4
        _this.echart_info_celltype2.tsne_minor.spotSize = 4
        _this.echart_info_celltype2.tsne_subset.spotSize = 4
      }
      for (let i = 0; i < _this.echart_info_celltype2.umap_major.types.length; i++) {
        _this.echart_info_celltype2.umap_major.tip.push({
          value: _this.echart_info_celltype2.umap_major.types[i],
          label: _this.echart_info_celltype2.umap_major.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info_celltype2.umap_minor.types.length; i++) {
        _this.echart_info_celltype2.umap_minor.tip.push({
          value: _this.echart_info_celltype2.umap_minor.types[i],
          label: _this.echart_info_celltype2.umap_minor.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info_celltype2.umap_subset.types.length; i++) {
        _this.echart_info_celltype2.umap_subset.tip.push({
          value: _this.echart_info_celltype2.umap_subset.types[i],
          label: _this.echart_info_celltype2.umap_subset.types[i],
          color: _this.COLOR_ALL[i]
        })
      }

      for (let i = 0; i < _this.echart_info_celltype2.tsne_major.types.length; i++) {
        _this.echart_info_celltype2.tsne_major.tip.push({
          value: _this.echart_info_celltype2.tsne_major.types[i],
          label: _this.echart_info_celltype2.tsne_major.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info_celltype2.tsne_minor.types.length; i++) {
        _this.echart_info_celltype2.tsne_minor.tip.push({
          value: _this.echart_info_celltype2.tsne_minor.types[i],
          label: _this.echart_info_celltype2.tsne_minor.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info_celltype2.tsne_subset.types.length; i++) {
        _this.echart_info_celltype2.tsne_subset.tip.push({
          value: _this.echart_info_celltype2.tsne_subset.types[i],
          label: _this.echart_info_celltype2.tsne_subset.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
    },
    async initEchartsInfo3() {
      let _this = this
      let temp_types = []
      _this.echart_info_celltype2.umap_celltype.source.push(['type', 'x', 'y'])
      _this.echart_info_celltype2.tsne_celltype.source.push(['type', 'x', 'y'])

      for (let i = 0; i < _this.data.length; i++) {
        _this.echart_info_celltype2.umap_celltype.source.push([_this.data[i].celltype, _this.data[i].UMAP_1, _this.data[i].UMAP_2])
        _this.echart_info_celltype2.tsne_celltype.source.push([_this.data[i].celltype, _this.data[i].tSNE_1, _this.data[i].tSNE_2])

        if (!temp_types.includes(_this.data[i].celltype)) {
          temp_types.push(_this.data[i].celltype)
        }
      }

      // console.log(_this.echart_info.classification_info.source)
      _this.echart_info_celltype2.umap_celltype.types = temp_types
      _this.echart_info_celltype2.tsne_celltype.types = temp_types
      if (_this.data.length > 5000) {
        _this.echart_info_celltype2.umap_celltype.spotSize = 2
        _this.echart_info_celltype2.tsne_celltype.spotSize = 2
      } else {
        _this.echart_info_celltype2.umap_celltype.spotSize = 4
        _this.echart_info_celltype2.tsne_celltype.spotSize = 4
      }
      for (let i = 0; i < _this.echart_info_celltype2.umap_celltype.types.length; i++) {
        _this.echart_info_celltype2.umap_celltype.tip.push({
          value: _this.echart_info_celltype2.umap_celltype.types[i],
          label: _this.echart_info_celltype2.umap_celltype.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
      for (let i = 0; i < _this.echart_info_celltype2.tsne_celltype.types.length; i++) {
        _this.echart_info_celltype2.tsne_celltype.tip.push({
          value: _this.echart_info_celltype2.tsne_celltype.types[i],
          label: _this.echart_info_celltype2.tsne_celltype.types[i],
          color: _this.COLOR_ALL[i]
        })
      }
    },
    getCelltypePic() {
      let _this = this
      // console.log(_this.$route.params.id)
      return new Promise((resolve) => {
        _this.$axios.get(
            'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/celltype/img2/' + _this.formData.datasetID + '/' + _this.formData.Array)
            .then(function (response) {
              // console.log("img:")
              // console.log(response)
              // _this.pic_path = response.data
              _this.pic_path.pic_celltype1 = response.data.celltype_1
              _this.pic_path.pic_celltype2 = response.data.celltype_2
              _this.pic_path.pic_major1 = response.data.major_1
              _this.pic_path.pic_major2 = response.data.major_2
              _this.pic_path.pic_minor1 = response.data.minor_1
              _this.pic_path.pic_minor2 = response.data.minor_2
              _this.pic_path.pic_subset1 = response.data.subset_1
              _this.pic_path.pic_subset2 = response.data.subset_2
              resolve()
            })
      })

    },
    getRCTD() {
      let _this = this
      // console.log(_this.formData.datasetID + '/' + _this.formData.Array)
      _this.$axios.get(
          'http://' + _this.$global.serverIP + ':' + _this.$global.serverHost + '/celltype/RCTDTable/' + _this.formData.datasetID + '/' + _this.formData.Array)
          .then(function (response) {
            // console.log('RCTD:')
            // console.log(response)
            _this.RCTD.data = eval('(' + response.data.rctd_data + ')')
            // console.log(_this.RCTD.data)
            _this.processRCTDData()
            _this.initEcharts()
          })
    },
    processRCTDData() {
      let _this = this
      // let temp = data_marker.test[0]
      // _this.RCTD.data = data_marker.test
      let temp = _this.RCTD.data[0]
      // console.log(temp)
      let keyData = Object.keys(temp)
      _this.columns = []
      for (let i = 0; i < keyData.length; i++) {
        if (keyData[i] !== 'spot' && keyData[i] !== 'x' && keyData[i] !== 'y') {
          _this.columns.push(keyData[i])
        }
      }
      // console.log(_this.columns)
    },
    initEcharts() {
      let _this = this
      let haveX = Object.prototype.hasOwnProperty.call(_this.RCTD.data[0], "x")
      let haveY = Object.prototype.hasOwnProperty.call(_this.RCTD.data[0], "y")
      // console.log(_this.RCTD.data[0])
      if (haveX && haveY){
        _this.changeJSONObject2ArrayWithPosition()
      }else {
        _this.changeJSONObject2Array()
      }
      let elementID = "rctd_vue"
      // console.log(elementID)
      const chartDom = document.getElementById(elementID);
      const myChart = echarts.init(chartDom);
      let option;
      const schema = [
        {name: 'no', index: 0, text: 'no'},
        {name: 'x', index: 1, text: 'x'},
        {name: 'y', index: 2, text: 'y'},
        {name: 'spot', index: 3, text: 'spot'},
        {name: 'expression', index: 4, text: 'expression'},
      ];
      const itemStyle = {
        emphasis: {
          focus: 'self'
        }
      };

      let _selected = {};
      let _series = []
      for (let i in _this.columns) {
        let temp = {
          type: 'scatter',
          itemStyle: itemStyle,
          // large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
          // largeThreshold: 5000,        //开启绘制优化的阈值。
          data: this.list_data[_this.columns[i]],
          symbolSize: 3,
          name: _this.columns[i],
        }
        _series.push(temp)
        if (i === 0) {
          _selected[_this.columns[i]] = true
        } else {
          _selected[_this.columns[i]] = false
        }
      }
      option = {
        color: ['#FF0000', '#FF8000', '#FFFF00', '#80FF00', '#00FF00', '#00FF80', '#00FFFF',
          '#0080FF', '#0000FF', '#7F00FF', '#FF00FF', '#FF007F', '#808080', '#FF7F7F'],
        toolbox: {
          top: 20,
          feature: {
            dataZoom: {
              show: true,
              title: {
                zoom: 'zoom',
                back: 'back'
              },
            },
            saveAsImage: {
              show: true,
              title: "save",
              pixelRatio: 15  //值越大分辨率越高,下载的图片越清晰
            },
          },
        },
        legend: {
          type: 'scroll',
          // orient: 'vertical',
          x: 'center',
          y: 'top',
          // top: 10,
          // padding: [
          //   5,  // 上
          //   10, // 右
          //   5,  // 下
          //   10, // 左
          // ],
          data: _this.columns,
          selectedMode: "single", // 单选
          selected: _selected,
          textStyle: {
            fontSize: 10
          }
        },
        // grid: {
        //   left: '15%',
        //   right: '15%',
        //   top: '5%',
        //   bottom: '5%'
        // },
        tooltip: {
          backgroundColor: 'rgba(255,255,255,0.7)',
          formatter: function (param) {
            // console.log(param)
            var value = param.value;
            // prettier-ignore
            return '<div style="border-bottom: 1px solid rgba(255,255,255,.3); font-size: 18px;padding-bottom: 7px;margin-bottom: 7px">'
                + param.seriesName
                + '</div>'
                // + schema[0].text + '：' + value[2] + '<br>'
                + schema[1].text + '：' + value[0] + '<br>'
                + schema[2].text + '：' + value[1] + '<br>'
                + schema[3].text + '：' + value[3] + '<br>'
                + schema[4].text + '：' + value[4] + '<br>';
          }
        },
        xAxis: {
          type: 'value',
          name: 'x',
          nameGap: 10,
          nameTextStyle: {
            fontSize: 10
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        yAxis: {
          type: 'value',
          name: 'y',
          nameLocation: 'end',
          nameGap: 10,
          nameTextStyle: {
            fontSize: 10
          },
          // max: 150,
          splitLine: {
            show: false
          }
        },
        visualMap: [
          {
            left: 'right',
            bottom: '30%',
            dimension: 4,
            type: 'continuous',
            calculable: true,                        //是否显示拖拽用的手柄（手柄能拖拽调整选中范围）
            realtime: true,                          //拖拽时，是否实时更新
            precision: 3,                            //数据展示的小数精度，默认为0，无小数点
            min: 0,
            max: 1,
            itemHeight: 120,
            align: "auto",
            text: ['expression'],
            textGap: 10,
            inRange: {
              // colorLightness: [1, 0.4],
              // color: ['#d9d9d9','blue']
              color: ['blue', 'yellow', 'red']
            },
            outOfRange: {
              color: ['rgba(255,255,255,0.4)']
            },
            controller: {
              inRange: {
                // color: ['#d9d9d9','blue']
                color: ['blue', 'yellow', 'red']
                // color: ['#c23531']
                // color: ['#FFFFFF']
              },
              outOfRange: {
                color: ['#999']
              }
            }
          }
        ],
        dataZoom: [
          {
            left: 0,
            type: 'slider', // 放大和缩小
            orient: 'vertical',
            width: 15
          },
          {
            type: "slider",
            height: 15,
          }
        ],
        grid: {
          right: 100
        },
        series: _series
      };
      myChart.off('legendselectchanged') //解决重复触发
      myChart.on('legendselectchanged', function (params) {
        // console.log('点击了', params.name);
        _this.type = params.name;
        // _this.getStateData();
        // myChart.setOption({
        //   legend:{selected:{[params.name]: true}}
        // })
        // do something
        _this.changeSelect()
      });
      option && myChart.setOption(option);
    },
    changeSelect() {
      let _this = this
      let elementID = "rctd_vue"
      // console.log(_this.type)
      const itemStyle = {
        emphasis: {
          focus: 'self'
        }
      };
      let _series = []
      for (let i in _this.columns) {
        let temp = {
          type: 'scatter',
          itemStyle: itemStyle,
          // large: true,                //是否开启大规模散点图的优化，在数据图形特别多的时候（>=5k）可以开启。开启后配合 largeThreshold 在数据量大于指定阈值的时候对绘制进行优化。缺点：优化后不能自定义设置单个数据项的样式。
          // largeThreshold: 5000,        //开启绘制优化的阈值。
          data: this.list_data[_this.columns[i]],
          symbolSize: 3,
          name: _this.columns[i],
        }
        _series.push(temp)
      }
      const myChart = echarts.getInstanceByDom(document.getElementById(elementID));
      // let option;
      myChart.setOption({
        legend: {selected: {[_this.type]: true}},
        series: _series
      })
      // chartDom.setAttribute('_echarts_instance_', '')
      // option && myChart.setOption(option,true);
    },
    changeJSONObject2Array() {
      let _this = this
      let res = {}
      let res_list = []
      // console.log(_this.position)
      for (let i = 0; i < _this.columns.length; i++) {
        res_list.push([])
      }
      for (let i in _this.RCTD.data) {
        // console.log(i)
        let temp_array = _this.RCTD.data[i]
        let index = _this.position.findIndex(item => item.spot === temp_array.spot)
        if (index !== -1 && _this.position[index].x !== '' && _this.position[index].x !== null) {
          for (let j in _this.columns) {
            let res_array = []
            let temp_type = _this.columns[j]
            res_array.push(_this.position[index].x)
            res_array.push(_this.position[index].y)
            res_array.push(Number(j))
            res_array.push(temp_array['spot'])
            res_array.push(temp_array[temp_type])
            res_list[j].push(res_array)
          }
        }
      }
      for (let j in _this.columns) {
        let temp_type = _this.columns[j]
        res[temp_type] = res_list[j]
      }
      _this.list_data = res
      // console.log(_this.list_data)
    },
    changeJSONObject2ArrayWithPosition() {
      let _this = this
      let res = {}
      let res_list = []
      for (let i = 0; i < _this.columns.length; i++) {
        res_list.push([])
      }
      for (let i in _this.RCTD.data) {
        // console.log(i)
        let temp_array = _this.RCTD.data[i]
        for (let j in _this.columns) {
          let res_array = []
          let temp_type = _this.columns[j]
          res_array.push(temp_array['x'])
          res_array.push(temp_array['y'])
          res_array.push(Number(j))
          res_array.push(temp_array['spot'])
          res_array.push(temp_array[temp_type])
          res_list[j].push(res_array)
        }
      }
      for (let j in _this.columns) {
        let temp_type = _this.columns[j]
        res[temp_type] = res_list[j]
      }
      _this.list_data = res
      // console.log(_this.list_data)
    },
    handleSizeChange(val) {
      this.pageinfo.currentPage = 1;
      this.pageinfo.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.pageinfo.currentPage = val;
    },
    rounding(row, column) {
      if (isNaN( parseFloat(row[column.property]).toFixed(8)) ){
        return row[column.property]
      }else {
        return parseFloat(row[column.property]).toFixed(8)
      }
    },

    CheckImgExists(imgurl) {
      var ImgObj = new Image(); //判断图片是否存在
      ImgObj.src = imgurl;
      //存在图片
      return ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0);
    },
    initLayoutData(){
      let index = 0
      let temp_layout = []
      if (this.asynGround !== '' || this.asynGround.length !== 0){
        temp_layout.push({
          x: Math.round((index % 3) * 4),
          y:  Math.round(index / 3),
          w: 4,
          h: 15,
          i: 'marker'+index.toString(),
          type: "TruthImageCard",
          data:{
            datasetID: this.formData.datasetID,
            groundtruth_source: this.asynGround
          }
        },)
        index++
      }
      let item;
      for(item in this.echart_info) {
        if (this.echart_info[item].source.length !== 0){
          let info_pic = ''
          switch (item) {
            case 'classification_info':
              info_pic = 'spatial domain';
              break;
            case 'annot_type_info':
              info_pic = 'anno_true';
              break;
            case 'fine_annot_type_info':
              info_pic = 'fine_anno_true';
              break;
            case 'celltype_info':
              info_pic = 'celltype';
              break;
            case 'major_info':
              info_pic = 'celltype_major';
              break;
            case 'minor_info':
              info_pic = 'celltype_minor';
              break;
            case 'subset_info':
              info_pic = 'celltype_subset';
              break;
          }
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'celltype'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info[item],
              info_type: info_pic
            },
          },)
          index++;
        }
      }
      for(item in this.echart_info_celltype2) {
        if (this.echart_info_celltype2[item].source.length !== 0){
          // console.log(item)
          temp_layout.push({
            x: Math.round((index % 3) * 4),
            y: Math.round(index / 3),
            w: 4,
            h: 15,
            i: 'celltype'+index.toString(),
            type: "InfoCard",
            data:{
              info: this.echart_info_celltype2[item],
              info_type: item
            },
          },)
          index++;
        }
      }

      for(item in this.pic_path) {
        // console.log(item)
        // console.log(this.pic_path[item])
        // console.log(this.CheckImgExists(this.pic_path[item]))
        if (this.CheckImgExists(this.pic_path[item])){
          temp_layout.push({
                x: Math.round((index % 3) * 4),
                y:  Math.round(index / 3),
                w: 4,
                h: 15,
                i: 'celltype'+index.toString(),
                type: "TruthImageCard",
                data:{
                  datasetID: -1,
                  groundtruth_source: this.pic_path[item],
                  picText: item.substring(4)
                }
              },)
          index++;
        }

      }

      this.layoutData = temp_layout
      // console.log(this.layoutData)
      this.index = index
      this.isGridShow = true
    },
  },
}
</script>

<style scoped>
#dataset_celltype_rctd {
  width: 100%;
  display: flex;
  /*flex-direction: column;*/
  justify-content: center;
  align-items: center;
}

.left {
  height: 450px;
  width: 900px;
  /*overflow-x: auto;*/
  /*overflow-y: auto;*/
  z-index: 0;
}

.left2 {
  height: 450px;
  width: 450px;
  z-index: 99;
}

.right {
  height: 450px;
  flex: 1;
  overflow-x: auto;
  overflow-y: auto;
  z-index: 99;
}

.right2 {
  height: 450px;
  flex: 1;
  z-index: 99;
  overflow-x: auto;
  overflow-y: auto;
}
</style>
